import React, { createContext, useContext } from 'react';

const ActionScopeContext = createContext('event');
const ActionSettingsPayloadContext = createContext(null);
const ActionSettingsCommandContext = createContext(null);
const ActionCaseIdContext = createContext(null);

export const ActionScopeProvider = ({ scope = 'event', caseid = null, setting = null, sendActionCommand = null, children }) => (
  <ActionSettingsCommandContext.Provider value={sendActionCommand}>
    <ActionSettingsPayloadContext.Provider value={setting}>
      <ActionCaseIdContext.Provider value={caseid}>
        <ActionScopeContext.Provider value={scope || 'event'}>
          {children}
        </ActionScopeContext.Provider>
      </ActionCaseIdContext.Provider>
    </ActionSettingsPayloadContext.Provider>
  </ActionSettingsCommandContext.Provider>
);

export const useActionScope = () => useContext(ActionScopeContext) || 'event';
export const useActionSettingsPayload = () => useContext(ActionSettingsPayloadContext);
export const useActionSettingsCommand = () => useContext(ActionSettingsCommandContext);
export const useActionCaseId = () => useContext(ActionCaseIdContext);

export default ActionScopeContext;
